// src/plugins/appVersion.ts
const logAppInfo = () => {
  const version = __APP_VERSION__ ?? '0.0.0';
  const stage = 'PROD';
  // const stage = (process.env.VUE_APP_STAGE || process.env.NODE_ENV || 'local') as string;
  const builtAt = __BUILD_TIME__ ?? '-';

  const title = 'color:#22c55e;font-weight:700';
  const label = 'color:#94a3b8;font-weight:600';
  const value = 'color:#e5e7eb';
  const sep = 'color:#64748b';
  const tip = 'color:#f59e0b;font-weight:600';

  // eslint-disable-next-line no-console
  console.groupCollapsed('%cAgent Console%c  •  %cBuild Info', title, sep, label);

  // eslint-disable-next-line no-console
  console.log('%cVersion:%c %s', label, value, version);
  // eslint-disable-next-line no-console
  console.log('%cStage:%c   %s', label, value, stage);
  // eslint-disable-next-line no-console
  console.log('%cBuilt:%c   %s', label, value, builtAt);

  // eslint-disable-next-line no-console
  console.log('%cTip:%c     Never paste or run code from strangers in this console.', tip, value);

  // eslint-disable-next-line no-console
  console.groupEnd();
};

export default logAppInfo;
